<template>
    <ul :class="{'paddingLeft':leave}"> 
        <li :class="{'fatherLi':!(Str.childList&&Str.childList.length)}" @click="showChild(Str)" v-show="includeCon||fatherShows"> 
            <span class="text">{{Str.name}}</span>
            <span :class="['icon',showOrNot?'arrowOn':'arrow']" v-show="Str.childList&&Str.childList.length"></span>
        </li>
        <dropdown-leave @fatherShow="fatherShow" v-show="Str.childList&&Str.childList.length&&showOrNot" v-for="(item,index) in Str.childList" :key="index" :Str="item" :leave="Str.childList&&Str.childList.length?true:false" :inputCon="inputCon"></dropdown-leave>
    </ul>
</template>
<script>
export default {
    name:'DropdownLeave',
    data(){
        return{
            showOrNot:true,
            fatherShows:false,
            cont:[]
        }
    },
    props:{
        Str:Object,
        leave:Boolean,
        inputCon:String
    },
    //跨级触发方法
    inject: ["fatherMethod"],
    computed:{
        includeCon(){
            return this.Str.name.indexOf(this.inputCon) > -1;
        }
    },
    watch:{
        inputCon: function (val) {
            if (val) {
                this.cont = [];
                if(this.includeCon){
                    this.$emit('fatherShow',true);
                    this.fatherMethod('t');
                }else{
                    this.$emit('fatherShow',false);
                    this.fatherMethod();
                }
            }
        }
    },
    methods:{
        showChild(Str){
            if(Str.childList&&Str.childList.length){
                this.showOrNot = !this.showOrNot;
            }else{
                this.open(Str.clientUrl);
            }
        },
        fatherShow(t){
            if(t){
                this.cont.push('=');
            }
            if(this.cont.length){
                this.fatherShows = true;
            }else{
                this.fatherShows = false;
            }
            
        }
    }
}
</script>
<style scoped>
.paddingLeft{
    padding-left: 10px;
}
li{
    padding: 6px;
    color: black;
    display: flex;
    justify-content: space-between;
}
li.fatherLi:hover{
    color: white;
    background-color: #5897fb;
}
.text{
    text-align: justify;
	text-overflow: ellipsis;
	word-break: break-all;
}
.icon{
    display: inline-block;
    width: 16px;
    height: 16px;
}
.arrow{
    background: url("../assets/images/icons/menu_close.png") no-repeat 0 3px;
}
.arrowOn{
    background: url("../assets/images/icons/menu_open.png") no-repeat 0 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/DropdownLeave.vue